import React, { useState } from "react";
import { useSelector } from "react-redux";
import styles from "./manageSource.module.scss";
import _ from "lodash";
import EmptyMessage from "../../../ui/emptyMessage";
import { MappingsBrowser } from "./entityBrowser/entityBrowser";
import Toast from "../../../ui/toast";

interface MappingsProps {
  onEntitySelection: (entity: any) => void;
}

const Mappings: React.FC<MappingsProps> = ({
  onEntitySelection,
}) => {
  const mappings = useSelector((state: any) => state.dataSourceInspector.items);

  const [selectedMapping, setSelectedMapping] = useState<any>(null);
  const [selectedFolder, setSelectedFolder] = useState<any>("");
  const [authErrorMappingId, setAuthErrorMappingId] = useState<string | null>(null);

  const selectedMappingInfo = _.find(mappings, { id: selectedMapping });

  const handleCreateMapping = (file: any) => {
    setSelectedFolder(prev => prev === file.id ? "" : file.id);
    onEntitySelection(file);
  };

  const onMappingSelection = (id: string) => {
    setSelectedMapping(id);
    if (authErrorMappingId && id !== authErrorMappingId) {
      setAuthErrorMappingId(null);
    }
  };

  const handleSetAuthToast = (value: boolean, mappingId: string) => {
    if (value) {
      setAuthErrorMappingId(mappingId);
    } else {
      setAuthErrorMappingId(null);
    }
  };

  const renderMappings = () => {
    return (
      <div className={styles.mappings}>
        <MappingsBrowser
          width={320}
          action={entity => {
            console.log("action", entity);
            return false;
          }}
          onMappingSelection={(id) => onMappingSelection(id)}
          onSelection={(file) => handleCreateMapping(file)}
          selectedFolder={selectedFolder}
          mappings={mappings}
          setAuthToast={(value: boolean) => handleSetAuthToast(value, selectedMapping || "")}
        />
      </div>
    );
  };

  return (
    <>
      {_.size(mappings) === 0 && (
        <div className={styles.emptyContainer}>
          <EmptyMessage
            width={400}
            image={'/images/dataSource/empty_connected_sources.svg'}
            heading="No connections found."
            message=""
          />
        </div>
      )}

      {_.size(mappings) > 0 && renderMappings()}

      {authErrorMappingId && selectedMappingInfo && (
        <Toast.warning
          heading="Authentication required"
          className={styles.authToast}
          closeToast={() => setAuthErrorMappingId(null)}
          message={
            <span>
              The authentication token to <span className={styles.storageName}>
                {selectedMappingInfo?.name + " " + selectedMappingInfo?.storageName}
              </span> content source has expired.
            </span>
          }
        />
      )}
    </>
  );
};

export default Mappings;